import { MapTriggerFunction, TealiumResultPayload } from '../types';

export const mapMerge =
    (...mappers: MapTriggerFunction[]): MapTriggerFunction =>
    (triggerName, payload, dataMapper): TealiumResultPayload =>
        mappers
            .map((mapper) => mapper(triggerName, payload, dataMapper))
            .reduce((prev, curr) => Object.assign(prev, curr), {});
